import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { User, UserEnrollment } from '../../models';
import { UsersServiceApi } from './users.service.api';
import { UsersServiceMock } from './users.service.mock';

export type LocalUser = Pick<User,
  'bankValidated' |
  'email' |
  'emailValidated' |
  'enrollmentStatus' |
  'fatherLastName' |
  'id' |
  'motherLastName' |
  'name' |
  'phoneNumber' |
  'profileDataCompleted'>;

export interface UpdateUserData {
  birthDate: Date;
  fatherLastName: string;
  motherLastName: string | null;
  name: string;
  phoneNumber: string;
}

@Injectable({
  providedIn: 'root',
  useClass: environment.usingMocks ? UsersServiceMock : UsersServiceApi,
})
export abstract class UsersService {
  abstract get<T extends User | UserEnrollment = User>(id: string): Observable<T | null>;
  abstract getCurrentUser<T extends User | UserEnrollment = User>(): Observable<T | null>;
  abstract updateUser(data: UpdateUserData): Promise<{ code: string; message: string; }>;
}

